import React from 'react';
import { StylishNewButton } from '../../DesignSystems/New/StylishNewButton';

interface AcknowledgeButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  variant?: 'warning' | 'primary' | 'success';
  size?: 'sm' | 'md';
  showIcon?: boolean;
  className?: string;
}

export const AcknowledgeButton: React.FC<AcknowledgeButtonProps> = ({
  onClick,
  isLoading = false,
  disabled = false,
  variant = 'warning',
  size = 'md',
  showIcon = true,
  className = '',
}) => {
  const buttonClass =
    `button--${variant}${size === 'sm' ? ' button--sm' : ''} ${className}`.trim();

  return (
    <StylishNewButton
      className={buttonClass}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <>
          <i className="fa fa-spinner fa-pulse me-2"></i>
          Acknowledging...
        </>
      ) : (
        <>
          {showIcon && (
            <i className="material-symbols-outlined me-2">check_circle</i>
          )}
          Acknowledge{size === 'sm' ? '' : ' Alert'}
        </>
      )}
    </StylishNewButton>
  );
};
